// extracted by mini-css-extract-plugin
export default {"row":"MunicipalityTrainingPlansRow_row__brn4R","schoolName":"MunicipalityTrainingPlansRow_schoolName__-iFmy","chart":"MunicipalityTrainingPlansRow_chart__XqX6j"};